import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
var _excluded = ["motionValue", "onUpdate", "onComplete", "element"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { secondsToMilliseconds } from 'motion-utils';
import { JSAnimation } from './JSAnimation.mjs';
import { NativeAnimation } from './NativeAnimation.mjs';
import { replaceTransitionType } from './utils/replace-transition-type.mjs';
import { replaceStringEasing } from './waapi/utils/unsupported-easing.mjs';
/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */

var sampleDelta = 10; //ms

var NativeAnimationExtended = /*#__PURE__*/function (_NativeAnimation) {
  _inherits(NativeAnimationExtended, _NativeAnimation);

  var _super = _createSuper(NativeAnimationExtended);

  function NativeAnimationExtended(options) {
    var _this;

    _classCallCheck(this, NativeAnimationExtended);

    /**
     * The base NativeAnimation function only supports a subset
     * of Motion easings, and WAAPI also only supports some
     * easing functions via string/cubic-bezier definitions.
     *
     * This function replaces those unsupported easing functions
     * with a JS easing function. This will later get compiled
     * to a linear() easing function.
     */
    replaceStringEasing(options);
    /**
     * Ensure we replace the transition type with a generator function
     * before passing to WAAPI.
     *
     * TODO: Does this have a better home? It could be shared with
     * JSAnimation.
     */

    replaceTransitionType(options);
    _this = _super.call(this, options);

    if (options.startTime) {
      _this.startTime = options.startTime;
    }

    _this.options = options;
    return _this;
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * Rather than read commited styles back out of the DOM, we can
   * create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to calculate velocity for any subsequent animation.
   */


  _createClass(NativeAnimationExtended, [{
    key: "updateMotionValue",
    value: function updateMotionValue(value) {
      var _this$finishedTime;

      var _this$options = this.options,
          motionValue = _this$options.motionValue,
          onUpdate = _this$options.onUpdate,
          onComplete = _this$options.onComplete,
          element = _this$options.element,
          options = _objectWithoutProperties(_this$options, _excluded);

      if (!motionValue) return;

      if (value !== undefined) {
        motionValue.set(value);
        return;
      }

      var sampleAnimation = new JSAnimation(_objectSpread(_objectSpread({}, options), {}, {
        autoplay: false
      }));
      var sampleTime = secondsToMilliseconds((_this$finishedTime = this.finishedTime) !== null && _this$finishedTime !== void 0 ? _this$finishedTime : this.time);
      motionValue.setWithVelocity(sampleAnimation.sample(sampleTime - sampleDelta).value, sampleAnimation.sample(sampleTime).value, sampleDelta);
      sampleAnimation.stop();
    }
  }]);

  return NativeAnimationExtended;
}(NativeAnimation);

export { NativeAnimationExtended };